module.exports = __webpack_public_path__ + "img/Unlocking-the-magic.e2a5a18b.png";